import React from "react";
import { graphql } from "gatsby";
import Form from "../components/Forms";
import { DefaultButton as Button } from "../components/Button";

import renderAst from "../utils/custom-classes";
import Layout from "../layouts";
import { getInsurance, getInsurancePDF } from "../actions";
import { client } from "../providers/Apollo";
import * as queries from "../actions/queries";

export default ({ data, pageContext }) => {
  const description = data.Description;
  const title = data.Title;
  const form = data.Form;
  const keywords = data.Keywords;

  const introduction = data.Introduction.childMarkdownRemark.htmlAst;
  const summaryHeading = data.Summary_heading;
  const summary = data.Summary.childMarkdownRemark.htmlAst;
  const mainImage = data.MainImage.url;

  const p1_heading = data.P1Heading;
  const p2_heading = data.P2Heading;
  const p3_heading = data.P3Heading;

  const p1_body = data.P1Body.childMarkdownRemark.htmlAst;
  const p2_body = data.P2Body.childMarkdownRemark.htmlAst;
  const p3_body = data.P3Body.childMarkdownRemark.htmlAst;

  const p1_image = data.P1Image[0].url;
  const p2_image = data.P2Image[0].url;
  const p3_image = data.P3Image[0].url;

  const { slug } = pageContext;

  console.log(p1_image);

  const orderId =
    typeof window !== `undefined`
      ? new URLSearchParams(window.location.search).get("orderId")
      : null;

  const [loading, changeLoading] = React.useState(false);
  React.useEffect(() => {
    if (slug === "/success/") {
      if (!orderId) {
        window.open("/sport", "_self");
      } else {
        getInsurance(orderId);
      }
    }
  }, []);

  const getInsurance = async (transactionId) => {
    changeLoading(true);
    try {
      const res = await client.mutate({
        mutation: queries.GET_ORDER_INFO,
        variables: {
          input: {
            orderId: transactionId,
          },
        },
      });

      const {
        updateOrderInfo: { insurance },
      } = res.data;

      window.dataLayer.push({
        event: "eec.purchase",
        ecommerce: {
          purchase: {
            actionField: {
              id: transactionId,
              revenue: insurance.totalPrice.toFixed(2),
            },
            products: insurance.pickedSports.map((x) => ({
              id: x.key,
              name: x.key,
              category: x.riskType,
              price: (insurance.totalPrice / insurance.insurers.length).toFixed(
                2
              ),
              quantity: insurance.insurers.length,
            })),
          },
        },

        // transactionId,
        // transactionTotal: insurance.totalPrice,
        // transactionProducts: insurance.pickedSports.map(x => ({
        //   sku: x.key,
        //   name: x.key,
        //   category: x.riskType,
        //   price: insurance.totalPrice/insurance.insurers.length,
        //   quantity: insurance.insurers.length,
        // })),
        // event: 'transactionComplete',
        // transaction: 'true',
      });
      // window.dataLayer.push({
      //   transactionId,
      //   transactionTotal: insurance.totalPrice,
      //   transactionProducts: insurance.pickedSports.map(x => ({
      //     sku: x.key,
      //     name: x.key,
      //     category: x.riskType,
      //     price: insurance.totalPrice/insurance.insurers.length,
      //     quantity: insurance.insurers.length,
      //   })),
      //   // event: 'transactionComplete',
      //   // transaction: 'true',
      // })
      changeLoading(false);
    } catch (error) {
      console.error(error);
      changeLoading(false);
    }
  };
  return (
    <Layout title={title} description={description} keywords={keywords}>
      <div className="container">
        <div className="template-content">
          {introduction.children.length > 0 && (
            <>
              <h1>{title}</h1>
              {mainImage && <img src={mainImage} alt="main sport" />}
              <p>{renderAst(introduction)}</p>
            </>
          )}

          {summary.children.length > 0 && (
            <>
              <h2>{summaryHeading}</h2>
              <p>{renderAst(summary)} </p>
            </>
          )}

          {p1_body.children.length > 0 && (
            <>
              <h1>{p1_heading}</h1>
              {p1_image && <img src={p1_image} alt="sport1" />}
              <p>{renderAst(p1_body)}</p>
            </>
          )}

          {p2_body.children.length > 0 && (
            <>
              <h1>{p2_heading}</h1>
              {p2_image && <img src={p2_image} alt="sport2" />}
              <p>{renderAst(p2_body)}</p>
            </>
          )}

          {p3_body.children.length > 0 && (
            <>
              <h1>{p3_heading}</h1>
              {p1_image && <img src={p3_image} alt="sport3" />}
              <p>{renderAst(p3_body)}</p>
            </>
          )}
        </div>
        {slug === "/success/" && orderId && (
          <div className="button-dpf-wrap">
            <Button
              onClick={() => {
                getInsurancePDF(orderId);
              }}
            >
              Скачать инофрмацию о страховке (PDF)
            </Button>
          </div>
        )}
        {form && <Form form={JSON.parse(form) || {}} />}
      </div>
    </Layout>
  );
};
